import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import _ from "lodash";
import { Div, Icon } from "@components/Generics.react";
import "@styles/components.scss";

export default function Banner(props) {
    const { ads } = props; // ads: {name, description, image, link}
    const [sequence, setSequence] = useState(0);
    const speed = 5000;

    useEffect(() => {
        ads.forEach((picture) => {
            const img = new Image();
            img.src = picture.image;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const carouselTimer = setTimeout(() => {
            setSequence(sequence < ads.length - 1 ? sequence + 1 : 0);
        }, speed);
        return () => clearInterval(carouselTimer);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sequence]);

    // ========================= Render Function =================================
    return (
        <Div fluid midnight rounded noOverflow relative className="banner">
            <Div relative className="banner-img">
                {ads[sequence].image && (
                    <Div className="resp-banner-img-container">
                        <img
                            src={ads[sequence].image}
                            className="fade-in-image"
                            alt={ads[sequence].name}
                        />
                    </Div>
                )}
                {ads[sequence].name && (
                    <Div
                        charcoal
                        bold
                        fit-content
                        small
                        className="banner-title"
                    >
                        {ads[sequence].name}
                    </Div>
                )}
                {ads.length > 1 && (
                    <Div className="dots">
                        {_.map(ads, (elm, n) => (
                            <Div
                                key={`dot-${n}`}
                                className={`dot ${n === sequence && "active"}`}
                                onClick={() => setSequence(n)}
                            />
                        ))}
                    </Div>
                )}
            </Div>
            {ads[sequence].description && (
                <Div minHt="80px" small bottomRounded half basepad>
                    {ads[sequence].description}
                </Div>
            )}
            {ads[sequence].link && ads[sequence].link.includes("http") && (
                <Div className="banner-link">
                    <a
                        href={ads[sequence].link}
                        target="_blank"
                        rel="noreferrer"
                    >
                        <Icon
                            name="play"
                            size="large"
                            rounded
                            inverted
                            primary
                            padded
                        />
                    </a>
                </Div>
            )}
            {ads[sequence].link && !ads[sequence].link.includes("http") && (
                <Div className="banner-link">
                    <NavLink to={ads[sequence].link}>
                        <Icon
                            name="play"
                            size="large"
                            rounded
                            inverted
                            primary
                            padded
                        />
                    </NavLink>
                </Div>
            )}
        </Div>
    );
}
